export function logout() {
    $('.menu-login_list-item-link, .dl-menu__logout').on('click touchend', function () {
        sessionStorage.removeItem('userState');
        sessionStorage.removeItem('profileData');
    });
}
